import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Flow } from 'signup-constants/Flow';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { isEnglishLanguage } from '../i18n/LanguageUtils';
import { getFlowKey } from '../routing/getFlowKey';
import { useTracker } from '../tracking/useTracker';
import { getIsMobile } from './deviceUtils';
import { getIsNewUserExperiment } from '../experiments/ExperimentUtils';
import { SignupEmbedder } from 'signup-embedder';
export const useChatBot = () => {
  const {
    currentStep
  } = useCurrentStep();
  const [loaded, setLoaded] = useState(false);
  const isNewUser = useSelector(getIsNewUserExperiment);
  const flowKey = getFlowKey();
  const Tracker = useTracker();
  useEffect(() => {
    const windowObject = window;

    const showBot = () => {
      const allowedFlows = [Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service, Flow.CmsFree];
      return !getIsMobile() && allowedFlows.includes(flowKey) && isEnglishLanguage() && !SignupEmbedder.isActive();
    };

    const setupChat = () => {
      if (showBot() && windowObject.HubSpotConversations.widget && !loaded) {
        windowObject.HubSpotConversations.widget.load();
        setLoaded(true); // it is actually not loaded but more like it's loading.
      }
    };

    if (windowObject.HubSpotConversations) {
      setupChat();
      windowObject.HubSpotConversations.on('conversationStarted', ({
        conversation
      }) => {
        Tracker.signupInteraction('chatbot-conversation-started', {
          currentStep,
          conversationId: conversation.conversationId
        });
      });
      windowObject.HubSpotConversations.on('conversationClosed', ({
        conversation
      }) => {
        Tracker.signupInteraction('chatbot-conversation-ended', {
          currentStep,
          conversationId: conversation.conversationId
        });
      });
    } else {
      windowObject.hsConversationsOnReady = [() => {
        setupChat();
      }];
    }

    return () => {
      if (!showBot() && loaded) {
        windowObject.HubSpotConversations.widget.remove();
        setLoaded(false);
      }
    };
  }, [currentStep, loaded, isNewUser, flowKey, Tracker]);
};